import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../primitive/Icon";

export const WhooshCrownLogo = (props: IconProps) => (
  <Icon viewBox="0 0 40 40" accessibilityLabel={t`Whoosh`} {...props}>
    <Path fill="#001A19" d="M0 0h40v40H0z" />
    <Path
      fill="#ACE5CF"
      d="M33.494 18.616c-.542-.584-1.477-.799-3.054.682-2.102 1.973-3.008 2.635-4.293 2.658a3.844 3.844 0 0 1-3.547-2.244c-.423-.923-.876-2.211-1.196-3.933-.093-.493-.397-.94-.87-1.145a1.188 1.188 0 0 0-.535-.101c-.188-.01-.37.032-.535.1-.473.206-.777.653-.87 1.146-.472 2.54-1.266 4.155-1.81 5.029a2.575 2.575 0 0 1-1.677 1.161c-1.5.3-2.997-.274-5.549-2.671-1.577-1.48-2.512-1.266-3.054-.682-.605.652-.641 1.634-.238 2.417l1.759 3.41c.324.63.973 1.026 1.681 1.026h20.589c.708 0 1.357-.396 1.681-1.025l1.76-3.411c.403-.786.363-1.765-.242-2.417Z"
    />
  </Icon>
);

export default WhooshCrownLogo;
